// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recommendations h2[data-v-01b96536]{color:#4d4d4d;font-size:1.25rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
